module.exports = __webpack_public_path__ + "f5e9090187e0707232df8fe599a15bc5.png";